import React, {useState} from 'react';
import {Typography, Box} from '@mui/material';

interface BenefitItemProps {
  name: string;
  description: string;
  isAppIimjobs: boolean;
  truncateLength?: number; // optional, default to 100
}

const BenefitItem: React.FC<BenefitItemProps> = ({
  name,
  description,
  isAppIimjobs,
  truncateLength = 120,
}) => {
  const [expanded, setExpanded] = useState(false);

  const toggleExpand = () => setExpanded(prev => !prev);

  const isTruncated = description.length > truncateLength;
  const displayedText =
    expanded || !isTruncated
      ? description
      : (() => {
          const slice = description.slice(0, truncateLength);
          const lastSpace = slice.lastIndexOf(' ');
          return slice
            .slice(0, lastSpace > 0 ? lastSpace : truncateLength)
            .trimEnd();
        })();

  return (
    <Box bgcolor="inherit">
      <Typography
        variant="subtitle3"
        lineHeight={'16px'}
        display="block"
        fontWeight={500}
        fontSize={isAppIimjobs ? 12 : 14}
      >
        {name}
      </Typography>
      {displayedText?.length > 0 && (
        <Typography
          component="span"
          sx={{
            display: 'inline-block', // ✅ gives line-height context
            color: 'text.secondary',
            fontSize: isAppIimjobs ? 12 : 14,
            fontWeight: {xxs: 400, md: 500},
            lineHeight: '16px', // ✅ now applies correctly
            opacity: isAppIimjobs ? 1 : 0.7,
            mt: 0.5,
            verticalAlign: 'middle',
          }}
        >
          <Box component="span" sx={{display: 'inline', lineHeight: 'inherit'}}>
            {displayedText}
          </Box>

          {isTruncated && (
            <Box
              component="span"
              onClick={toggleExpand}
              sx={{
                display: 'inline',
                cursor: 'pointer',
                ml: 0.5,
                fontSize: isAppIimjobs ? 12 : 14,
                fontWeight: 400,
                color: 'primary.main',
                lineHeight: 'inherit',
                verticalAlign: 'middle',
                userSelect: 'none',
              }}
            >
              {expanded ? 'Read less' : 'Read more'}
            </Box>
          )}
        </Typography>
      )}
    </Box>
  );
};

export default BenefitItem;
